// Get Restaurants
export const RESTAURANTS_REQUEST = "RESTAURANTS_REQUEST";
export const RESTAURANTS_SUCCESS = "RESTAURANTS_SUCCESS";
export const RESTAURANTS_FAILURE = "RESTAURANTS_FAILURE";

//Store
export const SERVING_RESTAURANTS_REQUEST = "SERVING_RESTAURANTS_REQUEST";
export const SERVING_RESTAURANTS_SUCCESS = "SERVING_RESTAURANTS_SUCCESS";
export const SERVING_RESTAURANTS_FAILURE = "SERVING_RESTAURANTS_FAILURE";
export const STORE_RESTAURANT_SERVING_LOCATIONS =
  "STORE_RESTAURANT_SERVING_LOCATIONS";

// Save Current Location
export const STORE_SELECTED_LOCATION = "STORE_SELECTED_LOCATION";
export const CLEAR_SELECTED_LOCATION = "CLEAR_SELECTED_LOCATION";

// Get Restaurant Details
export const RESTAURANT_DETAIL_REQUEST = "RESTAURANT_DETAIL_REQUEST";
export const RESTAURANT_DETAIL_SUCCESS = "RESTAURANT_DETAIL_SUCCESS";
export const RESTAURANT_DETAIL_FAILURE = "RESTAURANT_DETAIL_FAILURE";

// Get Restaurant by location Id
export const RESTAURANT_DETAIL_LOCATION_ID_REQUEST =
  "RESTAURANT_DETAIL_LOCATION_ID_REQUEST";
export const RESTAURANT_DETAIL_LOCATION_ID_SUCCESS =
  "RESTAURANT_DETAIL_LOCATION_ID_SUCCESS";
export const RESTAURANT_DETAIL_LOCATION_ID_CLEAR =
  "RESTAURANT_DETAIL_LOCATION_ID_CLEAR";

// Get Active Order Restaurants
export const ACTIVE_ORDER_RESTAURANT_REQUEST =
  "ACTIVE_ORDER_RESTAURANT_REQUEST";
export const ACTIVE_ORDER_RESTAURANT_SUCCESS =
  "ACTIVE_ORDER_RESTAURANT_SUCCESS";
export const ACTIVE_ORDER_RESTAURANT_CLEAR = "ACTIVE_ORDER_RESTAURANT_CLEAR";

// Get Restaurant Menu Details
export const RESTAURANT_MENU_DETAIL_REQUEST_BY_DATE =
  "RESTAURANT_MENU_DETAIL_REQUEST_BY_DATE";

export const RESTAURANT_MENU_DETAIL_REQUEST = "RESTAURANT_MENU_DETAIL_REQUEST";
export const RESTAURANT_MENU_DETAIL_SUCCESS = "RESTAURANT_MENU_DETAIL_SUCCESS";
export const RESTAURANT_MENU_DETAIL_FAILURE = "RESTAURANT_MENU_DETAIL_FAILURE";
export const CLEAR_RESTAURANT_DETAIL = "CLEAR_RESTAURANT_DETAIL";
export const REFRESH_MENU_DETAIL = "REFRESH_MENU_DETAIL";

//Feedback form
export const FEEDBACK_DETAIL_REQUEST = "FEEDBACK_DETAIL_REQUEST";
export const FEEDBACK_DETAIL_SUCCESS = "FEEDBACK_DETAIL_SUCCESS";
export const FEEDBACK_DETAIL_FAILURE = "FEEDBACK_DETAIL_FAILURE";
//Submit Feedback form
export const SUBMIT_FEEDBACK_DETAIL_REQUEST = "SUBMIT_FEEDBACK_DETAIL_REQUEST";
export const SUBMIT_FEEDBACK_DETAIL_SUCCESS = "SUBMIT_FEEDBACK_DETAIL_SUCCESS";
export const SUBMIT_FEEDBACK_DETAIL_FAILURE = "SUBMIT_FEEDBACK_DETAIL_FAILURE";
export const CLEAR_FEEDBACK_DATA = "CLEAR_FEEDBACK_DATA";
// store menu item for customisation
export const STORE_MENU_ITEM = "STORE_MENU_ITEM";

// Master HomePage Details
export const GET_MASTER_HOME_PAGE_DETAILS = "GET_MASTER_HOME_PAGE_DETAILS";
export const GET_MASTER_HOME_PAGE_DETAILS_SUCCESS =
  "GET_MASTER_HOME_PAGE_DETAILS_SUCCESS";
export const GET_MASTER_HOME_PAGE_DETAILS_ERROR =
  "GET_MASTER_HOME_PAGE_DETAILS_ERROR";

// Restaurant Table Details
export const GET_RESTAURANT_TABLE_DETAILS = "GET_RESTAURANT_TABLE_DETAILS";
export const GET_RESTAURANT_TABLE_DETAILS_SUCCESS =
  "GET_RESTAURANT_TABLE_DETAILS_SUCCESS";
export const GET_RESTAURANT_TABLE_DETAILS_FAILED =
  "GET_RESTAURANT_TABLE_DETAILS_FAILED";

export const RESTAURANT_ORDER_TYPE_SWITCH_SUCCESS =
  "RESTAURANT_ORDER_TYPE_SWITCH_SUCCESS";

export const UPDATE_CD_GUEST_COUNT = "UPDATE_CD_GUEST_COUNT";

export const UPDATE_RESTAURANT_STATUS = "UPDATE_RESTAURANT_STATUS";

export const CURRENT_ORDERTYPE_ID = "CURRENT_ORDERTYPE_ID";
export const CURRENT_ORDER_TYPE = "CURRENT_ORDER_TYPE";
export const CURRENT_CUSTOMIZATION_ID = "CURRENT_CUSTOMIZATION_ID";
export const DELIVERY_ADDRESSES = "DELIVERY_ADDRESSES";
export const SELECTED_DELIVERY_ADDRESS = "SELECTED_DELIVERY_ADDRESS";
export const ADD_ADDRESS_TAGS = "ADD_ADDRESS_TAGS";

export const VIEW_DELIVERY_ADDRESS_REQUEST = "VIEW_DELIVERY_ADDRESS_REQUEST"
export const VIEW_DELIVERY_ADDRESS_SUCCESS = "VIEW_DELIVERY_ADDRESS_SUCCESS"
export const VIEW_DELIVERY_ADDRESS_FAILURE = "VIEW_DELIVERY_ADDRESS_FAILURE"

export const ADD_DELIVERY_ADDRESS_REQUEST = "ADD_DELIVERY_ADDRESS_REQUEST"
export const ADD_DELIVERY_ADDRESS_SUCCESS = "ADD_DELIVERY_ADDRESS_SUCCESS"
export const ADD_DELIVERY_ADDRESS_FAILURE = "ADD_DELIVERY_ADDRESS_FAILURE"

export const EDIT_DELIVERY_ADDRESS_REQUEST = "EDIT_DELIVERY_ADDRESS_REQUEST"
export const EDIT_DELIVERY_ADDRESS_SUCCESS = "EDIT_DELIVERY_ADDRESS_SUCCESS"
export const EDIT_DELIVERY_ADDRESS_FAILURE = "EDIT_DELIVERY_ADDRESS_FAILURE"

export const DELETE_DELIVERY_ADDRESS_REQUEST = "DELETE_DELIVERY_ADDRESS_REQUEST"
export const DELETE_DELIVERY_ADDRESS_SUCCESS = "DELETE_DELIVERY_ADDRESS_SUCCESS"
export const DELETE_DELIVERY_ADDRESS_FAILURE = "DELETE_DELIVERY_ADDRESS_FAILURE"

export const ADD_FAV_REQUEST = "ADD_FAV_REQUEST"
export const ADD_FAV_SUCCESS = "ADD_FAV_SUCCESS"
export const ADD_FAV_FAILURE = "ADD_FAV_FAILURE"

export const REMOVE_FAV_REQUEST = "REMOVE_FAV_REQUEST"
export const REMOVE_FAV_SUCCESS = "REMOVE_FAV_SUCCESS"
export const REMOVE_FAV_FAILURE = "REMOVE_FAV_FAILURE"

export const GET_FAV_REQUEST = "GET_FAV_REQUEST"
export const GET_FAV_SUCCESS = "GET_FAV_SUCCESS"
export const GET_FAV_FAILURE = "GET_FAV_FAILURE"

// FavMap actions Blink issue 
export const SET_FAV_MAP = "SET_FAV_MAP"
export const UPDATE_FAV_MAP = "UPDATE_FAV_MAP"


export const REMOVE_DELIVERY_ADDRESS = "REMOVE_DELIVERY_ADDRESS"

// Selected Restaurant Tab
export const SET_SELECTED_RESTAURANT_TAB = "SET_SELECTED_RESTAURANT_TAB";

// Selected Delivery Type
export const SET_SELECTED_DELIVERY_TYPE = "SET_SELECTED_DELIVERY_TYPE";


//Explore Menu
export const GET_EXPLORE_MENU_REQUEST = "GET_EXPLORE_MENU_REQUEST"
export const GET_EXPLORE_MENU_SUCCESS = "GET_EXPLORE_MENU_SUCCESS"
export const GET_EXPLORE_MENU_FAILURE = "GET_EXPLORE_MENU_FAILURE"

export const IS_ANNOUNCEMENT_OPEN = "IS_ANNOUNCEMENT_OPEN"

export const TOGGLE_CLICK="TOGGLE_CLICK"

export const RESET_RESTAURANT="RESET_RESTAURANT"

export const UPDATE_CURRENT_ACTIVE_MENU = "UPDATE_CURRENT_ACTIVE_MENU";

export const IS_EXPLORE_TAB_ACTIVE = 'IS_EXPLORE_TAB_ACTIVE';
export const TOGGLE_STATUS="TOGGLE_STATUS";
export const SELECTED_INGREDIENT_CHECKLIST = 'SELECTED_INGREDIENT_CHECKLIST';


export const GET_COUPONS_REQUEST="GET_COUPONS_REQUEST"
export const GET_COUPONS_SUCCESS="GET_COUPONS_SUCCESS"
export const GET_COUPONS_FALIURE="GET_COUPONS_FALIURE"


export const VALIDATE_COUPONS_REQUEST="VALIDATE_COUPONS_REQUEST"
export const VALIDATE_COUPONS_SUCCESS="VALIDATE_COUPONS_SUCCESS"
export const VALIDATE_COUPONS_FALIURE="VALIDATE_COUPONS_FALIURE"
export const VALIDATE_COUPONS_FALIURE_MESSAGE="VALIDATE_COUPONS_FALIURE_MESSAGE"
export const VALIDATE_COUPONS_MSG_CLEAR="VALIDATE_COUPONS_MSG_CLEAR"


export const REDEEM_COUPONS_REQUEST="REDEEM_COUPONS_REQUEST"
export const REDEEM_COUPONS_SUCCESS="REDEEM_COUPONS_SUCCESS"
export const REDEEM_COUPONS_FALIURE="REDEEM_COUPONS_FALIURE"

export const APPLIED_COUPON="APPLIED_COUPON"
export const CLEAR_APPLIED_COUPON="CLEAR_APPLIED_COUPON"

